module.exports = __webpack_public_path__ + "static/media/PhoneIcon.d20fe272.svg";